import { render, staticRenderFns } from "./MobMethod.vue?vue&type=template&id=0f657438&scoped=true&"
import script from "./MobMethod.vue?vue&type=script&lang=js&"
export * from "./MobMethod.vue?vue&type=script&lang=js&"
import style0 from "./MobMethod.vue?vue&type=style&index=0&id=0f657438&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f657438",
  null
  
)

export default component.exports